export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7100.274b3053.jpg";